import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ReactNode } from "react";

interface MobileDeckBuilderProps {
  mainboardCardCount: number;
  sideboardCardCount: number;
  searchTabContent: ReactNode;
  listTabContent: ReactNode;
  controls: ReactNode;
  edhrecButton?: ReactNode;
  quickAdd?: ReactNode;
  commanderCardIds?: string[];
}

export const MobileDeckBuilder = ({
  mainboardCardCount,
  sideboardCardCount,
  searchTabContent,
  listTabContent,
  controls,
  edhrecButton,
  quickAdd,
  commanderCardIds = [],
}: MobileDeckBuilderProps) => {
  return (
    <div className="lg:hidden h-full flex flex-col">
      <Tabs defaultValue="search" className="h-full flex flex-col">
        <TabsContent value="search" forceMount className="flex-grow overflow-y-auto data-[state=inactive]:hidden">
          {searchTabContent}
        </TabsContent>
        <TabsContent value="list" className="flex-grow h-[calc(100vh-7rem)] relative">
          <div className="flex flex-col h-full">
            {/* Header section with deck count and actions */}
            <div className="flex-shrink-0 px-1 border-b bg-background/95 backdrop-blur-sm z-20">
              <div className="flex items-center gap-2 justify-between mb-2">
                {quickAdd}
                {commanderCardIds.length > 0 && edhrecButton}
              </div>
            </div>
            {/* Scrollable content */}
            <div className="flex-grow overflow-y-scroll relative z-10">
              {listTabContent}
            </div>
            {/* Controls at bottom - only show if there are cards */}
            {(mainboardCardCount + sideboardCardCount) > 0 && (
              <div className="flex-shrink-0 px-1 pb-0 pt-2 bg-background/95 backdrop-blur-sm border-t z-20">
                {controls}
              </div>
            )}
          </div>
        </TabsContent>
        <TabsList className="grid w-full grid-cols-2 mt-2 relative z-0">
          <TabsTrigger value="search">Search</TabsTrigger>
          <TabsTrigger value="list">List ({mainboardCardCount + sideboardCardCount})</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};
